import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, AxiosPublicAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_SABRE,
  gAPI_Ingetration,
  API_PARTNER_SABRE,
  postAPI_Sync_Room,
} from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { Tooltip } from 'reactstrap';
import Validation from '../../../../../../components/Validation';
import { FaSpinner, FaCheckCircle, FaTimesCircle, FaCheck } from 'react-icons/fa';
import { HiDocumentText, HiBadgeCheck } from "react-icons/hi";

let arr = [];
export default function SabreIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [isValidating, setIsValidating] = useState(false);
  const [singleValidationLoading, setSingleValidationLoading] = useState({});
  const [validationSummary, setValidationSummary] = useState({
    success: 0,
    failed: 0,
  });
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    UserName: '',
    Password: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [validationStatus, setValidationStatus] = useState({});
  const [initialProperties, setInitialProperties] = useState([]);

  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: 'SynXis',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    UserName: '',
    Password: '',
    HotelCode: '',
    Domain: '',
    ShowRates: false,
    ShowAvailability: false,
    ShowRatesAllRoom: false,
    ShowRatesSelectedRoom: false,
    RatePlanCode: '',
    ChannelCode: '',
    ChannelId: '',
  });
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_SABRE}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties: res.data.properties || [],
            UserName: res.data.channelDetails.userName,
            Password: res.data.channelDetails.password,
            Domain: res.data.channelDetails.domain,
            HotelCode: res.data.channelDetails.hotelCode,
            ChannelCode: res.data.channelDetails.channelCode,
            ChannelId: res.data.channelDetails.channelId,
            ShowRates: res.data.channelDetails.showRates,
            ShowAvailability: res.data.channelDetails.showAvailability,
            ShowRatesAllRoom: res.data.channelDetails.showRatesAllRoom,
            ShowRatesSelectedRoom:
              res.data.channelDetails.showRatesSelectedRoom,
            RatePlanCode: res.data.channelDetails.ratePlanCode,
          });

          setInitialProperties(res.data.properties || []);
          if (res.data.channelDetails.showRates === true) {
            setRatesRadios(true);
          }

          setMaskData({
            ...maskData,
            UserName: mask(res.data.channelDetails.userName),
            Password: mask(res.data.channelDetails.password),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleRateChange = (e) => {
    if (e.target.checked === true) {
      setRatesRadios(true);
      if (
        inputData.ShowRatesAllRoom === false &&
        inputData.ShowRatesSelectedRoom === false
      ) {
        setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
      }
    } else {
      setRatesRadios(false);
    }
    setInputData({ ...inputData, ShowRates: e.target.checked });
  };

  const handleShowAllChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesAllRoom: e.target.checked,
        ShowRatesSelectedRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
    }
  };

  const handleShowSelectedChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesSelectedRoom: e.target.checked,
        ShowRatesAllRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesSelectedRoom: e.target.checked });
    }
  };

  const handleAvailabilityChange = (e) => {
    setInputData({ ...inputData, ShowAvailability: e.target.checked });
  };

  const handleRatePlanChangeChange = (e) => {
    setInputData({ ...inputData, RatePlanCode: e.target.value });
  };

  const handleApiKeyChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setMaskData({ ...maskData, UserName: mask(e.target.value) });
    setInputData({ ...inputData, UserName: e.target.value });
    //console.log(inputData)
  };
  const handlePasswordChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setMaskData({ ...maskData, Password: mask(e.target.value) });
    setInputData({ ...inputData, Password: e.target.value });
    //console.log(inputData)
  };
  const handleHotelDetailsChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleDomainChange = (e) => {
    setSuccessMessage('');
    e.persist();
    setInputData({ ...inputData, Domain: e.target.value });
  };
  const handleCheckChange = (e) => {
    const { value, checked } = e.target;

    let updatedProperties = [...inputData.Properties];

    if (checked) {
      if (!updatedProperties.includes(value)) {
        updatedProperties.push(value);
      }
    } else {
      updatedProperties = updatedProperties.filter(
        (propertyId) => propertyId !== value
      );
    }
    setInputData({
      ...inputData,
      Properties: updatedProperties,
    });
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const selectableProperties = property
        .filter(p => p.providerPropertyId)
        .map(p => p.id);

      setInputData({
        ...inputData,
        Properties: selectableProperties,
      });
    } else {
      setInputData({
        ...inputData,
        Properties: [],
      });
    }
  };

  const validateSingleProperty = async (propertyId) => {
    const selectedProperty = property.find((p) => p.id === propertyId);
    if (!selectedProperty || !selectedProperty.providerPropertyId) return;

    setSuccessMessage('');
    setSingleValidationLoading((prev) => ({ ...prev, [propertyId]: true }));
    try {
      const res = await AxiosPublicAPI({
        method: 'post',
        url: `${API_PARTNER_SABRE}/validate`,
        data: {
          userName: inputData?.UserName,
          password: inputData?.Password,
          channelId: inputData?.ChannelId,
          channelCode: inputData?.ChannelCode,
          domain: inputData?.Domain,
          hotelCode: selectedProperty.providerPropertyId,
        },
      });

      setValidationStatus((prev) => ({
        ...prev,
        [propertyId]: res.data && res.data.length > 0 ? 'success' : 'failed',
      }));
    } catch (error) {
      setValidationStatus((prev) => ({ ...prev, [propertyId]: 'failed' }));
    } finally {
      setSingleValidationLoading((prev) => ({ ...prev, [propertyId]: false }));
    }
  };


  const validateIntegration = async () => {
    setSuccessMessage('');
    setIsValidating(true);

    let successCount = 0;
    let failedCount = 0;

    const results = { ...validationStatus };

    for (const propertyId of inputData.Properties) {
      const selectedProperty = property.find(p => p.id === propertyId);


      if (!selectedProperty || !selectedProperty.providerPropertyId) {
        continue;
      }

      try {
        const res = await AxiosPublicAPI({
          method: 'post',
          url: `${API_PARTNER_SABRE}/validate`,
          data: {
            userName: inputData?.UserName,
            password: inputData?.Password,
            channelId: inputData?.ChannelId,
            channelCode: inputData?.ChannelCode,
            domain: inputData?.Domain,
            hotelCode: selectedProperty.providerPropertyId,
          }
        });

        if (res.data && res.data.length > 0) {
          results[propertyId] = 'success';
          successCount++;
        } else {
          results[propertyId] = 'failed';
          failedCount++;
        }

      } catch (error) {
        results[propertyId] = 'failed';
        failedCount++;
      }
      setValidationStatus({ ...results });
    }
    setIsValidating(false);
    setValidationSummary({
      success: successCount,
      failed: failedCount,
    });

    setSuccessMessage('VALIDATION_COMPLETED');

  };

  const getValidatedProperties = () => {
    return inputData.Properties.filter(
      (propertyId) => validationStatus[propertyId] === 'success'
    );
  };
  const handleSave = async () => {
    setSuccessMessage('');
    const validatedProperties = getValidatedProperties();
    if (id === undefined) {
      if (validatedProperties.length === 0) {
        NotificationManager.warning(
          'Please validate at least one property before creating integration.',
          'Warning',
          3000
        );
        return;
      }
      const payload = {
        ...inputData,
        Properties: validatedProperties,
      };
      AxiosAPI({
        method: 'post',
        url: API_SABRE,
        data: payload,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => window.location.reload(), 300);
        }
      });
      return;
    }
    const newlyAddedProperties = inputData.Properties.filter(
      (pid) => !initialProperties.includes(pid)
    );
    const newlyAddedValidatedProperties = validatedProperties.filter(
      (pid) => newlyAddedProperties.includes(pid)
    );

    const uniqueFinalProperties = Array.from(
      new Set([
        ...initialProperties,
        ...newlyAddedValidatedProperties,
      ])
    );

    if (id !== undefined) {
      if (newlyAddedProperties.length === 0) {
        const payload = {
          ...inputData,
          Properties: inputData.Properties,
        };
        AxiosAPI({
          method: 'put',
          url: `${API_SABRE}/${id}?group_id=${getGroupID()}`,
          data: payload,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            toggle();
            setTimeout(() => window.location.reload(), 300);
          }
        });
        return
      }
      if (validatedProperties.length === 0) {
        NotificationManager.warning(
          'Some newly selected properties are not valid. Please validate at least one of them before updating.',
          'Warning',
          3000
        );
        return;
      }

      const payload = {
        ...inputData,
        Properties: uniqueFinalProperties,
      };
      AxiosAPI({
        method: 'put',
        url: `${API_SABRE}/${id}?group_id=${getGroupID()}`,
        data: payload,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => window.location.reload(), 300);
        }
      });

    }
  };

  return (
    <Fragment>
      <style>{`
           .spin {
          animation: spin 1s linear infinite;
          }

          @keyframes spin {
           from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }`
      }</style>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>
                  {id === undefined ? 'Add' : 'Update'} SynXis Channel Connect
                  Integration
                </h6>
                <p>
                  Add your Channel Connect credentials to establish connection.
                  This will allow your AI Knowledge Hub to pull hotel
                  description and availability/rates from SynXis.
                </p>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      value={inputData.Name}
                      readOnly
                      placeholder="SynXis"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>User Name</Label>
                    <Input
                      type="text"
                      name="UserName"
                      onChange={handleApiKeyChange}
                      placeholder="User Name"
                      defaultValue={maskData.UserName}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Password</Label>
                    <Input
                      type="text"
                      name="Password"
                      onChange={handlePasswordChange}
                      placeholder="Password"
                      defaultValue={maskData.Password}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Domain</Label>
                    <Input
                      type="text"
                      name="Domain"
                      onChange={handleDomainChange}
                      placeholder="Domain"
                      defaultValue={inputData.Domain}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Channel Code</Label>
                    <Input
                      type="text"
                      name="ChannelCode"
                      onChange={handleHotelDetailsChange}
                      placeholder="Channel Code"
                      defaultValue={inputData.ChannelCode}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Channel Id</Label>
                    <Input
                      type="text"
                      name="ChannelId"
                      onChange={handleHotelDetailsChange}
                      placeholder="Channel Id"
                      defaultValue={inputData.ChannelId}
                    />
                  </FormGroup>
                  <Separator className="mb-3" />
                  <FormGroup className="mb-2" style={{ display: 'none' }}>
                    <div className="">
                      <CustomInput
                        key="ShowAvailability"
                        type="checkbox"
                        label="Show Availability Summary in Rooms View"
                        name="ShowAvailability"
                        checked={inputData.ShowAvailability}
                        onChange={handleAvailabilityChange}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <div className="">
                      <CustomInput
                        key="showRates"
                        type="checkbox"
                        label="Show Rates & Availability in AI Chatbot Calendar"
                        name="showRates"
                        checked={inputData.ShowRates}
                        onChange={handleRateChange}
                      />
                    </div>
                  </FormGroup>
                  <p>Select the property this integration applies to:</p>
                  {showRatesRadios && (
                    <Fragment>
                      {' '}
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showallrooms'}
                            type="radio"
                            label={'Show Lowest Rate Among All Rooms'}
                            name="showRatesAllRoom"
                            checked={inputData.ShowRatesAllRoom}
                            onChange={handleShowAllChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showselectedrooms'}
                            type="radio"
                            label={'Show Lowest Rate For The Selected Room'}
                            name="showRatesSelectedRoom"
                            checked={inputData.ShowRatesSelectedRoom}
                            onChange={handleShowSelectedChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1">
                        <div className="">
                          <Label className="mt-3">
                            Use Specific Rate Plan To Fetch Rates{' '}
                            <i
                              className="demo-icon simple-icon-info"
                              id="titletip"
                            ></i>
                          </Label>
                          <Tooltip
                            placement="right"
                            isOpen={titleToolTip}
                            target="titletip"
                            toggle={toggleTitleToolTip}
                          >
                            Copy the rate plan from iHotelier to the field
                            below, this is usually the rate plan you have
                            specifically created for Myma.ai
                          </Tooltip>
                          <Input
                            type="text"
                            onChange={handleRatePlanChangeChange}
                            value={inputData.RatePlanCode}
                            name="RatePlanCode"
                            maxLength={50}
                            placeholder={'Rate Plan Code'}
                          />
                        </div>
                      </FormGroup>
                    </Fragment>
                  )}

                  <FormGroup className="mb-2">
                    <div className="integration-property">

                      {/* Select All */}
                      <CustomInput
                        type="checkbox"
                        id="selectAll"
                        label="Select All"
                        checked={
                          property
                            .filter(p => p.providerPropertyId)
                            .map(p => p.id)
                            .every(id => inputData.Properties.includes(id))
                        }
                        onChange={handleSelectAll}
                      />

                      {property.map((p) => (
                        <div key={p.id} style={{ display: 'flex', alignItems: 'center' }}>
                          <CustomInput
                            type="checkbox"
                            id={p.id}
                            name="property"
                            value={p.id}
                            checked={inputData.Properties.includes(p.id)}
                            disabled={!p.providerPropertyId}
                            label={
                              p.providerPropertyId
                                ? `${p.name} (${p.providerPropertyId})`
                                : `${p.name} (-)`
                            }
                            onChange={handleCheckChange}
                          />

                          {p.providerPropertyId &&
                            inputData.Properties.includes(p.id) &&
                            validationStatus[p.id] !== 'success' && (
                              <button
                                type="button"
                                onClick={() => validateSingleProperty(p.id)}
                                disabled={!!singleValidationLoading[p.id] || isValidating}
                                title="Validate this property"
                                style={{
                                  marginLeft: 5,
                                  padding: 0,
                                  border: 'none',
                                  background: 'transparent',
                                  cursor:
                                    !!singleValidationLoading[p.id] || isValidating
                                      ? 'not-allowed'
                                      : 'pointer',
                                  color: '#2a93d5',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                }}
                              >
                                {singleValidationLoading[p.id] ? (
                                  <FaSpinner className="spin" />
                                ) : (
                                  <div style={{ position: "relative", width: 20, height: 20 }}>
                                    <HiDocumentText size={16} color='var(--theme-color-1)' />
                                    <HiBadgeCheck
                                      size={10}
                                      color='var(--theme-color-1)'
                                      style={{
                                        position: "absolute",
                                        bottom: 1,
                                        right: -1,
                                        background: "#fff",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  </div>

                                )}
                              </button>
                            )}

                          {p.providerPropertyId &&
                            inputData.Properties.includes(p.id) &&
                            validationStatus[p.id] === 'success' && (
                              <span style={{ color: 'green', marginLeft: 8 }}>✔</span>
                            )}

                          {p.providerPropertyId &&
                            inputData.Properties.includes(p.id) &&
                            validationStatus[p.id] === 'failed' && (
                              <span style={{ color: 'red', marginLeft: 8 }}>✖</span>
                            )}
                        </div>
                      ))}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                  <Button
                    color="dark"
                    size="xs"
                    outline
                    onClick={validateIntegration}
                  >
                    Validate Integration
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
            {isValidating && (
              <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%' }}>
                <FaSpinner className="spin" />
                <span>Validating selected properties, please wait...</span>
              </div>
            )}

            <Colxx className="text-center">
              {successMessage === 'VALIDATION_COMPLETED' && !isValidating && (
                <div style={{ marginTop: 10, display: "flex", justifyContent: 'center', gap: '10px' }}>
                  {validationSummary.success > 0 && (
                    <div style={{ color: 'green', display: 'flex', alignItems: 'center', gap: 6 }}>
                      <FaCheckCircle />
                      {validationSummary.success} property(s) validated successfully
                    </div>
                  )}

                  {validationSummary.failed > 0 && (
                    <div style={{ color: 'red', display: 'flex', alignItems: 'center', gap: 6 }}>
                      <FaTimesCircle />
                      {validationSummary.failed} property(s) are not valid
                    </div>
                  )}
                </div>
              )}

            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
